import React from "react";
function Main() {
  return (
    <div id="main">
      <h1>Welcome to Derpwall, home of the derps, may I derp a wall for you?</h1>
      <div className="flex-row">
        <div className="get-started half">
          <h2>Getting Started</h2>
          <hr />
          <p>It's super easy! All you have to do is follow these simple steps: </p>
          <ol>
            <li>Create a Browser Source on your streaming application (OBS, Streamlabs, etc...)</li>
            <li>Copy and paste this url into the browser source configuration:
              <br />
              https://derpstuff.herokuapp.com/derpwall?channel=channel_name
            </li>
            <li>Change channel_name to your Twitch name. <b>Example:</b>
              <br />
              https://derpstuff.herokuapp.com/derpwall?channel=botsical
            </li>
          </ol>
        </div>

        <div className="specs half">
          <h2>Specifications</h2>
          <hr />
          <ul>
            <li>Derpwall is designed for 1920x1080 resolution</li>
            <li>Emotes are sized at 56x56 and may grow/shrink depending on animation</li>
          </ul>
        </div>

        <div className="commands full">
          <h2>Kappagen</h2>
          <hr />
          <div className="flex-row sub">
            <div className="half no-border no-padding no-margin">
              <h3>Instructions</h3>
              <div className="dotted" />
              <p>To use kappagen, enter this command in chat:</p>
              <p>!k &lt;emote&gt; &lt;shape&gt;</p>
              <p>Example: !k heart 💛</p>
              <p>It doesn't matter which order you enter them</p>
            </div>
            <div className="half no-border no-padding no-margin">
              <h3>Shapes</h3>
              <div className="dotted" />
              <ul>
                <li>Bear</li>
                <li>Cat</li>
                <li>Duck</li>
                <li>Heart</li>
                <li>Star</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="contact half">
          <h2>Known Issues</h2>
          <hr />
          <ul>
            <li>Sometimes Derpwall doesn't work when first loading OBS. To fix, simply refresh the overlay.</li>
          </ul>
        </div>

        <div className="contact half">
          <h2>Contact</h2>
          <hr />
          <p>Suggestions and bug reports can be made to me at:</p>
          <ul>
            <li><a href="https://discordapp.com/users/220292103219970058/" target="_new">Discord</a></li>
            <li><a href="mailto:bot@kerwinhy.com">Email</a></li>
          </ul>
        </div>
      </div>
      <h4>Derpwall created with 💛 by <a href="https://twitch.tv/derpsicalmusic" target="_new">DerpsicalMusic</a></h4>
    </div>
  )
}

export default Main;